export interface RuntimeConfig {
  supabaseUrl: string
  supabasePublishableKey: string
  turnstileSiteKey: string
  siteUrl: string
  authEmailDomain: string
  demoMode: boolean
}

declare global {
  interface Window {
    __FEEDBACK_CONFIG__?: RuntimeConfig
  }
}

function buildFallback(): RuntimeConfig {
  const origin = typeof window === 'undefined' ? 'http://localhost' : window.location.origin
  return {
    supabaseUrl: import.meta.env.VITE_SUPABASE_URL || '',
    supabasePublishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || '',
    turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY || '',
    siteUrl: import.meta.env.VITE_SITE_URL || origin,
    authEmailDomain: import.meta.env.VITE_AUTH_EMAIL_DOMAIN || 'access.feedback.kuzeyalmanya.de',
    demoMode: import.meta.env.VITE_DEMO_MODE === 'true',
  }
}

export async function loadRuntimeConfig() {
  try {
    const response = await fetch('/api/config', { headers: { accept: 'application/json' } })
    if (!response.ok) throw new Error(`Konfiguration konnte nicht geladen werden (${response.status}).`)
    const config = await response.json() as RuntimeConfig
    window.__FEEDBACK_CONFIG__ = config
  } catch {
    window.__FEEDBACK_CONFIG__ = buildFallback()
  }
}

export function runtimeConfig() {
  return (typeof window === 'undefined' ? undefined : window.__FEEDBACK_CONFIG__) || buildFallback()
}
